module.exports = __webpack_public_path__ + "img/police.d0289dc0.png";